var _a;
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { ETranslationScope } from "@sequentech/ui-core";
import { required, SelectInput } from "react-admin";
import { useTranslation } from "react-i18next";
var scopeFallbackLabels = (_a = {},
    _a[ETranslationScope.GLOBAL] = "Global",
    _a[ETranslationScope.VOTING_PORTAL] = "Voting portal",
    _a[ETranslationScope.BALLOT_VERIFIER] = "Ballot verifier",
    _a[ETranslationScope.RESULTS_PORTAL] = "Results portal",
    _a[ETranslationScope.ADMIN_PORTAL] = "Admin portal",
    _a[ETranslationScope.TEMPLATES] = "Reports and messages",
    _a);
export var translationScopeLabel = function (t, scope, legacyScope) {
    if (!scope) {
        var legacyPortalLabel = String(t("electionEventScreen.localization.scopes.".concat(legacyScope), {
            defaultValue: scopeFallbackLabels[legacyScope],
        }));
        return String(t("electionEventScreen.localization.scopes.legacy", {
            defaultValue: "Legacy (".concat(scopeFallbackLabels[legacyScope], ")"),
            portal: legacyPortalLabel,
        }));
    }
    return String(t("electionEventScreen.localization.scopes.".concat(scope), {
        defaultValue: scopeFallbackLabels[scope],
    }));
};
export var TranslationScopeInput = function (_a) {
    var allowedScopes = _a.allowedScopes, defaultValue = _a.defaultValue, source = _a.source;
    var t = useTranslation().t;
    var choices = allowedScopes.map(function (scope) { return ({
        id: scope,
        name: translationScopeLabel(t, scope, defaultValue),
    }); });
    return (_jsx(SelectInput, { source: source, label: String(t("electionEventScreen.localization.labels.scope", { defaultValue: "Portal scope" })), choices: choices, validate: required(), defaultValue: defaultValue, fullWidth: true }));
};
